// Lazy Swiper init — only initialize when container enters viewport
// Prevents 1,200ms+ of forced reflows from autoHeight on page load
function initSwiperOnVisible(selector, config) {
  var el = document.querySelector(selector);
  if (!el) return;
  var observer = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting) {
      new Swiper(selector, config);
      observer.disconnect();
    }
  }, { rootMargin: '300px 0px' });
  observer.observe(el);
}

initSwiperOnVisible('.testimonial-slider', {
  loop: true,
  navigation: {
    nextEl: '.testimonial-section .swiper-button-next',
    prevEl: '.testimonial-section .swiper-button-prev',
  },
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '.testimonial-section .swiper-pagination',
    clickable: true
  }
});

// blog slider [ blog hero section ]
initSwiperOnVisible('.hero-blogslider', {
  loop: true,
  navigation: {
    nextEl: '.blog-hero-section .swiper-button-next',
    prevEl: '.blog-hero-section .swiper-button-prev',
  },
  slidesPerView: 1,
  spaceBetween: 0,
  dots: true,
  pagination: {
    el: '.blog-hero-section .swiper-pagination',
    clickable: true
  }
});
// blog slider [ blog hero section ]

// press-release-hero slider
initSwiperOnVisible('.press-releaseslider', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  dots: true,
  pagination: {
    el: '.press-release-hero .swiper-pagination',
    clickable: true
  }
});
// press-release-hero slider
// --- Pincode localStorage restore (init function for consolidated DOMContentLoaded) ---
function initPincodeLocalStorage() {
  try {
    const pincodeInput = document.querySelector("input#pincode");
    const inputCheck = document.querySelector(".pin-check");

    if (pincodeInput) {
      const prePincode = localStorage.getItem("pincodeval");
      if (prePincode) {
        pincodeInput.value = prePincode; // Don't use parseInt to avoid dropping leading 0
      }
    }

    if (inputCheck && pincodeInput) {
      inputCheck.addEventListener("click", function () {
        localStorage.setItem("pincodeval", pincodeInput.value);
      });
    }
  } catch (err) {
    console.warn("Error****", err);
  }
}

// Consolidated DOMContentLoaded — single listener calls all init functions
// (previously 4 separate listeners, consolidated to avoid race conditions)
document.addEventListener("DOMContentLoaded", function () {
  initPincodeLocalStorage();
  initProductPageUI();
  initShareAndCartUI();
  initPincodeKeydown();
});



// Home page lookingForOne section tabbing
var tab_wrapper = document.querySelector(".lookinForOne.content_wrapper");
if (tab_wrapper) {
  var tab_headings = tab_wrapper.querySelectorAll(".content_tab_wrapper .tab_heading_wrapper");
  var allContents = tab_wrapper.querySelectorAll(".products_wrapper");

  if (tab_headings.length) {
    tab_headings.forEach((tabHeading) => {
      tabHeading.addEventListener('click', function () {
        tab_headings.forEach((th) => th.classList.remove("active"));
        allContents.forEach((content) => content.classList.remove("active"));

        this.classList.add("active");
        var tab_title = this.getAttribute("data-title");
        var matchedcontent = tab_wrapper.querySelector('.products_wrapper[data-contant-tab="' + tab_title + '"]');

        if (matchedcontent) {
          matchedcontent.classList.add("active");
        }
      });
    });
  }
}
// Home page lookingForOne section tabbing

//Home page lookingForOne section mobile tabbing
var productTabs = document.querySelectorAll(".content_produts_wrapper .products_wrapper");
if (productTabs.length) {
  productTabs.forEach((productTab) => {
    productTab.addEventListener('click', function () {
      productTabs.forEach((tab) => {
        tab.classList.remove("active");
        tab.querySelector(".tab_heading_wrapper").classList.remove("active");
      });
      this.classList.add('active');
      productTab.querySelector(".tab_heading_wrapper").classList.add("active");
    });
  });
}
//Home page lookingForOne section mobile tabbing

// DISABLED: Megamenu should open on CLICK, not hover
// Header open menu toggle on menu hover
// let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
// if(items){
//   items.forEach(item => {
//    item.addEventListener("mouseover", () => {
//     item.setAttribute("open", true);
//      item.querySelector("ul, .megamenu-image-block.mega_menu_2").addEventListener("mouseleave", () => {
//        item.removeAttribute("open");
//      });
//      item.addEventListener("mouseleave", () => {
//        item.removeAttribute("open");
//      });
//    });
//   });
// }
// Header open menu toggle on menu hover

// Main Blog page -- For mobile view
// var selectorButton = document.querySelector(".main-blog .mobile-select-button");
// if(selectorButton){
//   selectorButton.addEventListener('click',function(){
//     selectorButton.closest(".blogtaglist-wrap").classList.toggle('active');
//   });
// }

// --- UI init: sizechart, focal points, blog, FAQ, compare, sticky bar, buy buttons, menu drawer ---
function initProductPageUI() {

  // // product page heightOption Tooltip
  // const heightTooltip = document.querySelector(".product-form__input.height .tooltip-title");
  // if(heightTooltip){
  //   heightTooltip.addEventListener('click',function(){
  //     this.classList.toggle('active');
  //   });
  // }
  // document.addEventListener('click', function(event) {
  //   if (
  //     !event.target.closest('.tooltip-button') &&
  //     !event.target.closest('.tooltip-popup')
  //   ) {
  //     heightTooltip?.classList.remove('active'); // Replace with the actual class you want to remove
  //   }
  // });


  // Sizechart popup
  const sizechartPopupButton = document.querySelector(".sizechart-popup-label");
  const sizechartPopup = document.querySelector(".sizechart-popup");
  const sizechartPopupCloseButton = document.querySelector(".popup-closebutton");
  const sizechartPopupOverlay = document.querySelector(".popup-overlay");
  const youtubeFrame = document.querySelector(".popup-video.media-box.third-party iframe");
  const measureBoxButton = document.querySelector(".Measure_box");

  function toggleSizechartPopup(show) {
    sizechartPopup.classList.toggle('active', show);
    sizechartPopupOverlay.classList.toggle('active', show);
  }

  if (sizechartPopupButton && sizechartPopup && sizechartPopupOverlay) {
    sizechartPopupButton.addEventListener('click', () => toggleSizechartPopup(true));
  }

  // Measure_box opens the same sizechart/video popup
  if (measureBoxButton && sizechartPopup && sizechartPopupOverlay) {
    measureBoxButton.addEventListener('click', () => toggleSizechartPopup(true));
  }

  if (sizechartPopupCloseButton && sizechartPopupOverlay) {
    sizechartPopupCloseButton.addEventListener('click', () => {
      toggleSizechartPopup(false);
      if (youtubeFrame) { youtubeFrame.src = youtubeFrame.src; }
    });
    sizechartPopupOverlay.addEventListener('click', () => {
      toggleSizechartPopup(false);
      if (youtubeFrame) { youtubeFrame.src = youtubeFrame.src; }
    });
  }




  // product page heightOption Tooltip

  // Focal points clickable functionality
  const points = document.querySelectorAll(".point-number");
  const pointRows = document.querySelectorAll(".pointlist-row");

  function removeActiveClasses() {
    points.forEach(point => point.classList.remove("active"));
    pointRows.forEach(row => row.querySelector(".pointlist-title").classList.remove("active"));
  }
  points.forEach(point => {
    point.addEventListener("click", function () {
      const index = this.className.match(/point(\d+)/)[1];

      removeActiveClasses(); // Remove existing active classes

      this.classList.add("active");
      document.querySelector(`.pointlist__${index} .pointlist-title`).classList.add("active");
    });
  });


  pointRows.forEach(row => {
    row.addEventListener("click", function () {
      const index = this.className.match(/pointlist__(\d+)/)[1];

      removeActiveClasses(); // Remove existing active classes

      this.querySelector(".pointlist-title").classList.add("active");
      document.querySelector(`.point${index}.point-number`).classList.add("active");
    });
  });
  // Focal points clickable functionality

  //main blog page
  var blogSection = document.querySelector(".main-blog");
  var selectorButton = blogSection?.querySelector(".mobile-select-button");
  var blogTagListWrap = blogSection?.querySelector(".custom-dropdown");

  if (selectorButton && blogTagListWrap) {
    selectorButton.addEventListener("click", function (event) {
      blogTagListWrap.classList.toggle("active");
      event.stopPropagation(); // Prevent click from bubbling to document
    });

    document.addEventListener("click", function (event) {
      if (!blogTagListWrap.contains(event.target)) {
        blogTagListWrap.classList.remove("active");
      }
    });
  }
  // main blog page

  // faq page
  var faqPage = document.querySelector(".faq-content");
  var faqSelectorButton = faqPage?.querySelector(".mobile-select-button");
  var tabListwrap = faqPage?.querySelector(".custom-dropdown");
  if (faqSelectorButton && tabListwrap) {
    faqSelectorButton.addEventListener("click", function (event) {
      tabListwrap.classList.toggle("active");
    });

    document.addEventListener("click", function (event) {
      if (!tabListwrap.contains(event.target)) {
        tabListwrap.classList.remove("active");
      }
    });
  }
  // faq page

  // Add on products on product page
  const addOnOptions = document.querySelectorAll(".addOnProducts-wrapper .color_option");
  if (addOnOptions.length) {
    addOnOptions.forEach(option => {
      option.addEventListener("click", function () {
        document.querySelectorAll(".color_option").forEach(optionelem => { optionelem.classList.remove('active'); });
        option.classList.add('active');

        const value = this.getAttribute("data-value");
        const selectedValEl = this.closest(".variant_list").querySelector(".selected_val");
        if (selectedValEl) {
          selectedValEl.textContent = value;
        }

        let variantId = this.getAttribute("data-variant-id"); // Get selected variant ID
        let variantListWrapper = this.closest(".variant_list"); // Get parent variant list
        let productVariants = JSON.parse(variantListWrapper.getAttribute("data-options")); // Get all variants

        // Find the selected variant
        let selectedVariant = productVariants.find(variant => variant.id == variantId);
        if (!selectedVariant) return;
        let product_wrapper = this.closest(".product_wrapper");
        if (product_wrapper) {
          product_wrapper.setAttribute("data-addon-id", variantId);
        }
        // Update the image
        let imageWrapper = this.closest(".product_wrapper").querySelector(".image_wrapper img");
        if (imageWrapper && selectedVariant.featured_image) {
          imageWrapper.src = selectedVariant.featured_image.src;
        }

        // Update the selected variant title
        let selectedVariantTitle = this.closest(".product_wrapper").querySelector(".selected_varinat");
        if (selectedVariantTitle) {
          selectedVariantTitle.textContent = selectedVariant.title;
        }

        // Update the prices
        let priceWrapper = this.closest(".product_wrapper").querySelector(".price_wrapper");
        if (priceWrapper) {
          let salePriceEl = priceWrapper.querySelector(".sale_price");
          let comparePriceEl = priceWrapper.querySelector(".compare_price");
          let discountPercentageEl = priceWrapper.querySelector(".discount_percentage");

          if (salePriceEl) {
            salePriceEl.setAttribute("data-sale_price", selectedVariant.price);
            salePriceEl.textContent = `+ ${Shopify.formatMoney(selectedVariant.price, Shopify.money_format).replace(/\.00$/, "")}`;
          }

          if (comparePriceEl) {
            if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
              comparePriceEl.setAttribute("data-compare_price", selectedVariant.compare_at_price);
              comparePriceEl.textContent = `+ ${Shopify.formatMoney(selectedVariant.compare_at_price, Shopify.money_format).replace(/\.00$/, "")}`;
              comparePriceEl.style.display = "inline";
            } else {
              comparePriceEl.style.display = "none";
            }
          }

          // Calculate and display the discount percentage
          if (discountPercentageEl) {
            if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
              let discount = ((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price).toFixed(0);
              discountPercentageEl.textContent = `(${discount}% OFF)`;
            } else {
              discountPercentageEl.textContent = "";
            }
          }
        }
      });
    });
    const selectedColor = document.querySelector(".addOnProducts-wrapper .color_option.active").getAttribute("data-value");
    // console.log("selected Color",selectedColor);
    document.querySelector(".addOnProducts-wrapper .variant_list .selected_val").textContent = selectedColor;
  }

  // Add on products on product page

  // comapre product section
  // function setupComparison(listClass, key, compareClass) {
  //   const compareListElement = document.querySelector(`.${listClass}`);
  //   if (!compareListElement) return;

  //   let compareListData = compareListElement.getAttribute("data-compare");
  //   if (!compareListData) {
  //       console.error(`No data-compare attribute found for ${listClass}.`);
  //       return;
  //   }

  //   try {
  //       compareListData = JSON.parse(compareListData);
  //   } catch (error) {
  //       console.error(`JSON Parsing Error in ${listClass}:`, error);
  //       return;
  //   }
  //   // console.log("compareListData",compareListData);
  //   if (!compareListData[key] || !Array.isArray(compareListData[key])) {
  //       console.error(`Invalid or missing ${key} array.`);
  //       return;
  //   }

  //   const compareList = compareListData[key];
  //   function updateComparison(itemId) {
  //       const product = compareList.find(p => p.id === itemId);
  //       if (!product) return;

  //       ["Ideal For", "Support", "Cover", "Base", "Motion Transfer", "Description", "Foam", "Height","Toxin Free","Trial Period","Warranty","Shipping","Material","Features","Wash Instructions","Cover Material","Sizes Available"].forEach(attr => {
  //         console.log("attr >>> ",attr);  
  //         const selector = `.${attr.toLowerCase().replace(/\s+/g, '_')} .${compareClass}`;
  //           const element = document.querySelector(selector);
  //           console.log("element >>> ", element);
  //           if (element) {
  //               let value = product[attr] || "";
  //                 console.log("value >>> ",value);
  //               if (attr === "Foam" || attr === 'Height' || attr === "Description") {
  //                   value = value.replace(/\n/g, "<br>");
  //               }
  //               element.innerHTML = `<p>${value}</p>`;
  //           }else {
  //               console.warn(`Element not found: ${selector}`);
  //           }
  //       });
  //   }

  //   function updateImage(item, itemId) {
  //     var imageSrc = item.getAttribute("data-image");
  //     var compare_block = item.closest(".table-product-info");
  //     const product = compareList.find(p => p.id === itemId);

  //     if (!product || !compare_block) return;

  //     var price = Shopify.formatMoney(product["price"], Shopify.money_format).replace(/\.00$/, '');
  //     var compare_price = Shopify.formatMoney(product["compare_price"], Shopify.money_format).replace(/\.00$/, '');
  //     var title = item.textContent;
  //     let compareClass = compare_block.classList.contains('compare_list_1') ? 'compare_list_1' : 
  //                        compare_block.classList.contains('compare_list_2') ? 'compare_list_2' : null;
  //     let imgClass = compareClass === 'compare_list_1' ? 'compare_1' : 'compare_2';

  //     if (compareClass) {
  //       let parentSelector = `.table-product-info.${compareClass}`;
  //       let imgSelector = `.table-product-info.${imgClass} img`;

  //       document.querySelector(imgSelector).src = imageSrc;

  //       let salePriceElement = document.querySelector(`${parentSelector} .sale_price`);
  //       let comparePriceElement = document.querySelector(`${parentSelector} .compare_price`);
  //       let buttonElement = document.querySelector(`${parentSelector} .button`);
  //       let dropdownElement = document.querySelector(`${parentSelector} .custom_dropdown_selected`);

  //       if (salePriceElement) salePriceElement.innerHTML = price;
  //       if (comparePriceElement) comparePriceElement.innerHTML = compare_price;
  //       if (buttonElement) buttonElement.textContent = title;
  //       if (dropdownElement) dropdownElement.textContent = title;
  //     }
  //   }

  //   const compareItems = document.querySelectorAll(`.${listClass} .compare-item`);
  //   compareItems.forEach(item => {
  //     item.addEventListener("click", function () {
  //       let dropdownList = this.closest(".custom_dropdown").querySelector(".custom_dropdown_listvalue");
  //       dropdownList.classList.remove('active');
  //       compareItems.forEach(item => {
  //         item.classList.remove('selected');
  //       });
  //       item.classList.add('selected');

  //       const itemId = parseInt(this.getAttribute("data-id"), 10);
  //       if (!isNaN(itemId)) updateComparison(itemId);
  //       updateImage(item,itemId);
  //     });
  //   });
  // }

  // setupComparison("compare_list_1", "compareList1", "compare_1");
  // setupComparison("compare_list_2", "compareList2", "compare_2");
  // document.querySelectorAll(".custom_dropdown_title").forEach(title => {
  //   title.addEventListener('click', function () {
  //     const dropdownList = this.nextElementSibling;
  //     if (dropdownList) {
  //       dropdownList.classList.toggle('active');
  //     }
  //   });
  // });

  function setupComparisonPage(listClass, key, compareClass, oppositeListClass) {
    // console.log("listClass >> ",listClass);
    const compareListElement = document.querySelector(`.${listClass}`);
    // console.log("compareListElement >>> ",compareListElement);
    const oppositeListElement = document.querySelector(`.${oppositeListClass}`);
    if (!compareListElement || !oppositeListElement) return;

    let compareListData = compareListElement.getAttribute("data-compare");
    if (!compareListData) {
      console.error(`No data-compare attribute found for ${listClass}.`);
      return;
    }

    try {
      compareListData = JSON.parse(compareListData);
    } catch (error) {
      console.error(`JSON Parsing Error in ${listClass}:`, error);
      return;
    }

    if (!compareListData[key] || !Array.isArray(compareListData[key])) {
      console.error(`Invalid or missing ${key} array.`);
      return;
    }

    const compareList = compareListData[key];

    function updateComparison(itemId) {
      const product = compareList.find(p => p.id === itemId);
      if (!product) return;

      [
        "Ideal For", "Support", "Cover", "Base", "Motion Transfer", "Description", "Why Choose This", "Foam", "Height",
        "Toxin Free", "Trial Period", "Warranty", "Shipping", "Material", "Features",
        "Wash Instructions", "Cover Material", "Sizes Available"
      ].forEach(attr => {
        const selector = `.${attr.toLowerCase().replace(/\s+/g, '_')} .${compareClass}`;
        const element = document.querySelector(selector);
        if (element) {
          let value = product[attr] || "";
          if (["Foam", "Height", "Description"].includes(attr)) {
            value = value.replace(/\n/g, "<br>");
          }
          element.innerHTML = `<p>${value}</p>`;
        }
      });
    }

    function updateImage(item, itemId) {
      const imageSrc = item.getAttribute("data-image");
      const productUrl = item.getAttribute("data-url");
      // console.log("imageSrc",imageSrc);
      const compare_block = item.closest(".table-product-info");
      const product = compareList.find(p => p.id === itemId);
      if (!product || !compare_block) return;

      const price = Shopify.formatMoney(product["price"], Shopify.money_format).replace(/\.00$/, '');
      const compare_price = Shopify.formatMoney(product["compare_price"], Shopify.money_format).replace(/\.00$/, '');
      const title = item.textContent;

      let compareClass = compare_block.classList.contains('compare_list_1') ? 'compare_list_1' :
        compare_block.classList.contains('compare_list_2') ? 'compare_list_2' : null;
      let imgClass = compareClass === 'compare_list_1' ? 'compare_1' : 'compare_2';

      if (compareClass) {
        let parentSelector = `.table-product-info.${compareClass}`;
        let imgSelector = `.table-product-info.${imgClass} img`;
        // console.log("imgSelector",imgSelector);
        const imgElement = document.querySelector(imgSelector);
        if (imgElement) imgElement.src = imageSrc;

        let salePriceElement = document.querySelector(`${parentSelector} .sale_price`);
        let comparePriceElement = document.querySelector(`${parentSelector} .compare_price`);
        let buttonElement = document.querySelector(`${parentSelector} .button`);
        let dropdownElement = document.querySelector(`${parentSelector} .custom_dropdown_selected`);

        if (salePriceElement) salePriceElement.innerHTML = price;
        if (comparePriceElement) comparePriceElement.innerHTML = compare_price;
        if (buttonElement) {
          buttonElement.textContent = ` Shop ${title}`;
          buttonElement.href = productUrl;
        }
        if (dropdownElement) dropdownElement.textContent = title;
      }
    }

    const compareItems = document.querySelectorAll(`.${listClass} .compare-item`);
    const oppositeItems = document.querySelectorAll(`.${oppositeListClass} .compare-item`);

    compareItems.forEach(item => {
      item.addEventListener("click", function () {
        const dropdownList = this.closest(".custom_dropdown").querySelector(".custom_dropdown_listvalue");
        dropdownList.classList.remove('active');

        compareItems.forEach(item => item.classList.remove('selected'));
        item.classList.add('selected');

        const itemId = parseInt(this.getAttribute("data-id"), 10);
        if (!isNaN(itemId)) updateComparison(itemId);
        updateImage(item, itemId);

        // ✨ NEW: Hide matching item from the opposite list
        const selectedText = this.textContent.trim();

        oppositeItems.forEach(opp => {
          // First unhide everything
          opp.classList.remove('hidden');
          // Then hide match
          if (opp.textContent.trim() === selectedText) {
            opp.classList.add('hidden');
          }
        });
      });
    });
  }

  setupComparisonPage("compare_list_1", "compareList1", "compare_1", "compare_list_2");
  setupComparisonPage("compare_list_2", "compareList2", "compare_2", "compare_list_1");
  document.querySelectorAll(".product-compare-section .custom_dropdown_title").forEach(title => {
    title.addEventListener('click', function () {
      const dropdownList = this.nextElementSibling;
      if (dropdownList) {
        dropdownList.classList.toggle('active');
      }
    });
  });

  // comapre product section

  // Middle sticky bar on product page
  let stickySwiper;

  const sections = document.querySelectorAll('.pdptab-data');
  if (sections.length > 0) {
    const stickyMenuContainer = document.querySelector('.sticky-bar-wrap .col.center-col .sticky-bar-content');

    const ul = document.createElement('ul');
    ul.classList.add('pdp-stickymenu', 'swiper-wrapper');

    sections.forEach((section, index) => {
      const sectionId = section.getAttribute('id');
      const sectionName = section.getAttribute('section_name');

      if (sectionId && sectionName) {
        // Create <li> element for each section
        const li = document.createElement('li');
        li.classList.add("swiper-slide");

        // Add 'active' class only to the first <li>
        if (index === 0) {
          li.classList.add('active');
        }
        const a = document.createElement('a');
        a.href = `#${sectionId}`;
        function capitalizeWords(str) {
          return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        }

        a.textContent = capitalizeWords(sectionName) || sectionName;  // Capitalize the first letter of each word


        li.appendChild(a);
        ul.appendChild(li);
      }
    });

    if (stickyMenuContainer) {
      stickyMenuContainer.appendChild(ul);

      stickySwiper = new Swiper(stickyMenuContainer, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slideToClickedSlide: true,
        freeMode: {
          enabled: true,
          sticky: false,
          momentumBounce: false,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          prevEl: '.sticky-nav-arrow--prev',
          nextEl: '.sticky-nav-arrow--next',
        },
      });

    }

  } else {
    document.querySelector(".product-sticky-bar .sticky-bar-wrap")?.classList.add('hidden');
  }

  const stickyMenuLinks = document.querySelectorAll(".pdp-stickymenu li a");

  // Cache DOM refs — these elements never change
  const stickyBarEl = document.querySelector('.product-sticky-bar');
  const headerEl = document.querySelector('.sticky-header');
  let isScrollingFromClick = false;
  let scrollClickTimer = null;
  let rafId = null;

  // Dynamic offset — accounts for header hidden state + sticky bar height
  function getStickyOffset() {
    const stickyBarH = stickyBarEl ? stickyBarEl.offsetHeight : 0;
    const isHeaderHidden = document.body.classList.contains('sticky-active');
    const headerH = (!isHeaderHidden && headerEl) ? headerEl.offsetHeight : 0;
    return headerH + stickyBarH + 10;
  }

  // Scroll to section when clicking on menu links
  stickyMenuLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href");
      const targetElement = document.querySelector(targetId);
      if (!targetElement) return;

      // Lock scroll spy during smooth scroll to prevent erratic tab switching
      isScrollingFromClick = true;
      clearTimeout(scrollClickTimer);

      // Immediately set clicked tab as active
      stickyMenuLinks.forEach(l => l.parentElement.classList.remove("active"));
      this.parentElement.classList.add("active");
      if (stickySwiper) {
        const slideIndex = [...this.parentElement.parentElement.children].indexOf(this.parentElement);
        stickySwiper.slideTo(slideIndex);
      }

      // Use getBoundingClientRect for reliable position
      const targetTop = targetElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetTop - getStickyOffset(),
        behavior: "smooth"
      });

      // Unlock scroll spy after smooth scroll completes (~600ms)
      scrollClickTimer = setTimeout(function() {
        isScrollingFromClick = false;
      }, 700);
    });
  });

  // Throttled scroll spy — runs at most once per animation frame
  function onScroll() {
    if (isScrollingFromClick) return; // Skip during click-initiated scroll

    if (rafId) return; // Already queued
    rafId = requestAnimationFrame(function() {
      rafId = null;
      if (!sections.length) return;

      const offset = getStickyOffset();

      // Find which section is currently in view using getBoundingClientRect
      let activeSection = null;
      sections.forEach(function(section) {
        const rect = section.getBoundingClientRect();
        // Section is "active" when its top is above the offset line and bottom is below it
        if (rect.top <= offset && rect.bottom > offset) {
          activeSection = section;
        }
      });

      if (!activeSection) return;

      const sectionId = activeSection.getAttribute("id");
      if (!sectionId) return;

      const activeLink = document.querySelector('.pdp-stickymenu li a[href="#' + sectionId + '"]');
      if (!activeLink || activeLink.parentElement.classList.contains("active")) return;

      // Update active state
      stickyMenuLinks.forEach(function(link) { link.parentElement.classList.remove("active"); });
      activeLink.parentElement.classList.add("active");

      if (stickySwiper) {
        const slideIndex = [...activeLink.parentElement.parentElement.children].indexOf(activeLink.parentElement);
        stickySwiper.slideTo(slideIndex);
      }
    });
  }
  window.addEventListener("scroll", onScroll, { passive: true });

  // when centred sticky bar scroll to the top then hide stickyHeader
  var productStickyBar = document.querySelector(".product-sticky-bar .sticky-bar-wrap");
  if (productStickyBar && !productStickyBar.classList.contains('hidden')) {
    const stickyHeader = document.querySelector("sticky-header");
    const stickyBarWrap = document.querySelector(".sticky-bar-wrap");
    if (stickyHeader && stickyBarWrap) {
      const stickyHeaderHeight = stickyHeader.offsetHeight; // Get sticky header height

      var stickyTicking = false;
      window.addEventListener("scroll", function () {
        if (!stickyTicking) {
          stickyTicking = true;
          requestAnimationFrame(function () {
            var stickyBarTop = stickyBarWrap.getBoundingClientRect().top;
            if (stickyBarTop <= stickyHeaderHeight) {
              document.body.classList.add("sticky-active");
            } else {
              document.body.classList.remove("sticky-active");
            }
            stickyTicking = false;
          });
        }
      }, { passive: true });
    }
  }
  // Product page centere sticky bar BackToTop button
  const backToTopBtn = document.querySelector(".backtotop_button");
  if (backToTopBtn) {
    backToTopBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Enables smooth scrolling
      });
    });
  }
  // Middle sticky bar on product page

  // custom Buy button for showing size selector error msg and for custom size add to Cart
  var customBuyButton = document.querySelector(".product__info-wrapper .custom_buy_button");
  if (customBuyButton) {
    customBuyButton.addEventListener('click', function () {
      const customOptActive = document.querySelector(".variant-pill-list-wrap .custom-size")?.classList.contains("active");
      if (!customOptActive) {
        var dropdown = document.querySelector(".product_customDropdown");
        if (dropdown) {
          // Check if error message already exists to prevent duplicates
          var existingError = dropdown.querySelector(".size-selection-error");
          if (!existingError) {
            var errorMessage = document.createElement("span");
            errorMessage.classList.add("size-selection-error");
            errorMessage.textContent = "Select appropriate size before adding to cart!";

            // Append the error message inside the dropdown
            dropdown.appendChild(errorMessage);
          }
        }
      } else {
        const variant_id = customBuyButton.getAttribute("data-variant-id");
        const quantity = document.querySelector(".product-form__quantity quantity-input input").value;
        const customsizeVal = customBuyButton.getAttribute("data-size");
        const isExactMatch = customBuyButton.getAttribute("isexactmatch");
        const variantTitle = customBuyButton.getAttribute("data-variant-title") || '';
        // console.log("isExactMatch",isExactMatch);
        if (isExactMatch == 'true') {
          if (variant_id && quantity) {
            const form_data = {
              items: [
                {
                  id: variant_id,
                  quantity: parseInt(quantity, 10),
                  properties: {
                    _VariantTitle: variantTitle
                  }
                }
              ]
            };

            custom_addtocart_fun(form_data, true);
            setTimeout(() => {
              document.querySelector(".header__icon.header-cart-icon")?.click();
            }, 500);
          }
        } else {
          if (variant_id && quantity) {
            const form_data = {
              items: [
                {
                  id: variant_id,
                  quantity: parseInt(quantity, 10),
                  properties: {
                    custom_size: customsizeVal,
                    _VariantTitle: variantTitle
                  }
                }
              ]
            };
            custom_addtocart_fun(form_data, true);
            setTimeout(() => {
              document.querySelector(".header__icon.header-cart-icon")?.click();
            }, 500);
          }
        }
      }
    });
  }
  // custom Buy button for showing size selector error msg

  // Product page bottom stickybar addToCart button click
  var stickyBuyButton = document.querySelector(".product-main-sticky-bar .sticky-addtocart-btn");
  if (stickyBuyButton) {
    stickyBuyButton.addEventListener('click', function () {
      const activeButton = document.querySelector(".buy-buttons-block.active button.product-form__submit");
      if (activeButton) {
        const soldOutBtn = stickyBuyButton.querySelector(".btn-text.sold-out");
        if (soldOutBtn) {
          document.querySelector(".email-me-button")?.click();
        } else {
          if (!document.querySelector('.buy-buttons-block.bed_pro_invalid')) {
            stickyBuyButton.querySelector('.loading__spinner').classList.remove('hidden');
          }
          // stickyBuyButton.querySelector(".loading__spinner").classList.remove('hidden');
          // Set flag to indicate this is a sticky button click
          activeButton.setAttribute('data-clicked-from', 'sticky');
          activeButton.click();
        }
      } else {
        const customBuyButton = document.querySelector(".custom_buy_button");
        if (customBuyButton) {
          customBuyButton.click();
          // Scroll to custom dropdown button after clicking the custom buy button
          document.querySelector(".custom-dropdown-button")?.scrollIntoView({
            behavior: 'smooth',  // Optional: adds smooth scrolling
            block: 'center'  // Optional: scrolls to the center of the page
          });
        }
      }

      const activeButton_bed = document.querySelector(".buy-buttons-block.bed_pro_invalid button");
      if (activeButton_bed) {
        const targetElement = document.querySelector("variant-selects");
        const header = document.querySelector("sticky-header"); // or whatever your header selector is

        if (targetElement) {
          const headerHeight = (header?.offsetHeight || 0) + 10;
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
          });
        }
      }

    });
  }
  // Product page bottom stickybar addToCart button click

  // menu drawer js for mobile view start
  const menuLinks = document.querySelectorAll('.mainmenu-link-wrap');

  if (menuLinks) {
    menuLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        const submenu = this.nextElementSibling;
        const isAlreadyActive = submenu.classList.contains('active');
        const parentLi = this.closest('.mainmenu-li');
        const scrollContainer = this.closest('.menu-drawer__navigation-container');

        // Close all accordions (with normal CSS transition)
        document.querySelectorAll('.submenulist-wrap').forEach(sub => {
          sub.classList.remove('active');
        });

        // Open the clicked one (if wasn't already active)
        if (!isAlreadyActive && submenu && submenu.classList.contains('submenulist-wrap')) {
          submenu.classList.add('active');
        }

        // Wait for close animation (100ms) to finish, then scroll to the section
        setTimeout(() => {
          if (scrollContainer && parentLi) {
            const targetTop = parentLi.offsetTop;
            scrollContainer.scrollTo({ top: targetTop, behavior: 'smooth' });
          }
        }, 150);
      });
    });
  }
  // menu drawer js for mobile view end
}


// START -- PDP page faq page

var headingTab = document.querySelector(".colgroup-wrap .left-col");
var contenetTab = document.querySelector(".colgroup-wrap .right-col");

if (headingTab && contenetTab) {
  var titlesElems = headingTab.querySelectorAll("li[data-faq-block]");

  titlesElems.forEach((titleElem) => {
    titleElem.addEventListener("click", function () {
      const selectedVal = this.textContent;
      document.querySelector(".mobile-select-button-text").textContent = selectedVal;
      document.querySelector(".faq-content .custom-dropdown").classList.remove('active');
      titlesElems.forEach((elem) => {
        elem.classList.remove("active");
      });
      contenetTab.querySelectorAll(".faqtab-info[data-button-name]").forEach((block) => {
        block.classList.add('hidden');
      })

      this.classList.add("active");

      var selectedTabTitle = this.getAttribute("data-faq-block");
      contenetTab.querySelector(".faqtab-info[data-button-name='" + selectedTabTitle + "']").classList.remove("hidden");
    });
  });
}

// END -- PDP page faq page


// START - Personalize product
var personalizeblock = document.querySelector(".personalize_product_block");
if (personalizeblock) {
  const personalize_btn = personalizeblock.querySelector(".personalize-tab_btn");
  var content_wrapper = personalizeblock.querySelector(".personalize-data-container");
  var personalize_input = personalizeblock.querySelector(".product_wrapper #textInput");
  var result_block = personalizeblock.querySelector(".personalization_result");
  var editTextBtn = personalizeblock.querySelector(".edit_personalization_btn");
  var finalTextElem = document.querySelector(".result_final_text");
  var personlizationPropertlyElem = document.querySelector("#personalization_text");
  const personalizeText = personalizeblock.querySelector(".personalize-text");
  var productQuantity = 1;
  window.addEventListener('productQuantityChanged', (event) => {
    const { quantity, id } = event.detail;
    productQuantity = quantity
  });

  personalize_btn.addEventListener('click', function () {
    content_wrapper.classList.toggle("hidden");
  });

  personalize_input.addEventListener("input", function (event) {
    let maxLength = parseInt(this.getAttribute("maxlength")); // Get max_length from attribute
    this.value = this.value.replace(/[^A-Za-z]/g, ""); // Allow only letters

    if (this.value.length >= maxLength) {
      this.value = this.value.substring(0, maxLength); // Ensure length doesn't exceed maxLength
    }
    personalizeText.textContent = this.value;
  });

  function scrollToPersonalizeBlock() {
    var header = document.querySelector("sticky-header");
    var headerHeight = header ? header.offsetHeight : 0;
    var blockPosition = personalizeblock.getBoundingClientRect().top + window.scrollY; // Get block position relative to the document
    var scrollPosition = blockPosition - headerHeight - 30; // Adjust with some extra space

    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth"
    });
  }
  const pincodeInput = document.querySelector(".pincode-wrapper input[id='pincode']");
  personalizeblock.querySelector(".product_wrapper .submit_btn").addEventListener("click", function () {
    // let inputField = document.getElementById("textInput");
    let errorMsg = document.querySelector(".personlization_error");
    let maxLength = parseInt(personalize_input.getAttribute("maxlength"));
    let minLength = parseInt(personalize_input.getAttribute("minlength"));
    let currentLength = personalize_input.value.length;

    if (currentLength < minLength) {
      errorMsg.style.display = "block";
      errorMsg.innerHTML = `You have to fill up at least ${minLength} letters to engrave.`;
      event.preventDefault();
      return;
    } else if (currentLength > maxLength) {
      event.preventDefault();
      return;
    } else {
      errorMsg.innerHTML = '';
      personalizeblock.querySelector(".product_wrapper").classList.add('hidden');
      result_block.classList.remove('hidden');
      finalTextElem.textContent = personalize_input.value.toUpperCase();
      var personalize_price = personalizeblock.querySelector("[data-price]").getAttribute("data-price");
      var formattedPersonlizePrice = Shopify.formatMoney(personalize_price, Shopify.money_format);
      const totalPersonalizePrice = personalize_price * productQuantity;

      var productForm = document.querySelector(".product-form form");
      if (productForm) {
        personlizationPropertlyElem = document.querySelector("#personalization_text");
        if (!personlizationPropertlyElem) {
          personlizationPropertlyElem = document.createElement("input");
          personlizationPropertlyElem.type = "hidden";
          personlizationPropertlyElem.name = "properties[_personalization_initials]";
          personlizationPropertlyElem.id = "personalization_text";
          productForm.appendChild(personlizationPropertlyElem);
        }
        personlizationPropertlyElem.value = personalize_input.value.toUpperCase() + " ( + " + formattedPersonlizePrice.replace(/\.00$/, '') + " included )";

        let intialsElem = document.querySelector("#intials_text");
        if (!intialsElem) {
          intialsElem = document.createElement("input");
          intialsElem.type = "hidden";
          intialsElem.name = "properties[Initials]";
          intialsElem.id = "intials_text";
          productForm.appendChild(intialsElem);
        }
        intialsElem.value = personalize_input.value.toUpperCase() + " ( + " + formattedPersonlizePrice.replace(/\.00$/, '') + " included )";

        // Personalization price input
        let priceElem = document.querySelector("#personalize_price");
        if (!priceElem) {
          priceElem = document.createElement("input");
          priceElem.type = "hidden";
          priceElem.name = "properties[_personalize_price]";
          priceElem.id = "personalize_price";
          productForm.appendChild(priceElem);
        }
        priceElem.value = personalize_price / 100;
      }
      let customSizeElem = document.querySelector("#personalize_custom");
      if (!customSizeElem) {
        customSizeElem = document.createElement("input");
        customSizeElem.type = "hidden";
        customSizeElem.name = "properties[_custom_size]";
        customSizeElem.id = "personalize_custom";
        productForm.appendChild(customSizeElem);
      }
      // else{
      //   customSizeElem = document.createElement("input");
      //   customSizeElem.name = "properties[_custom_size]";
      // }
      // customSizeElem.name = "properties[_custom_size]";
      customSizeElem.value = true;

      result_block.setAttribute("personlization", true);
      if (pincodeInput) pincodeInput.setAttribute("data-custom", true);

      scrollToPersonalizeBlock();
    }
  });
  personalizeblock.querySelector(".product_wrapper .remove_btn").addEventListener("click", function () {
    personalize_input.value = '';
    content_wrapper.classList.add('hidden');
    result_block.classList.add('hidden');

    // Remove personalization hidden inputs if they exist
    let personlizationPropertlyElem = document.querySelector("#personalization_text");
    if (personlizationPropertlyElem) personlizationPropertlyElem.remove();

    let intialsPropertyElem = document.querySelector("#intials_text");
    if (intialsPropertyElem) intialsPropertyElem.remove();

    let priceElem = document.querySelector("#personalize_price");
    if (priceElem) priceElem.remove();

    let personlaize_cutomEL = document.querySelector("#personalize_custom");
    if (personlaize_cutomEL) personlaize_cutomEL.remove();

    result_block.setAttribute("personlization", false);
    if (pincodeInput) pincodeInput.setAttribute("data-custom", false);

    scrollToPersonalizeBlock();
    personalizeText.textContent = '';
  });

  editTextBtn.addEventListener('click', function () {
    result_block.classList.add("hidden");
    personalizeblock.querySelector(".product_wrapper").classList.remove('hidden');
  });
}
// END - Personalize product

// const quantitycontainer = document.querySelector('.price-per-item__container');
// if (quantitycontainer) {
//   const quantityEl = quantitycontainer.querySelector('.quantity');
//   if (quantityEl && quantityEl.dataset.url?.includes('dog-beds')) {
//     var productForm = document.querySelector(".product-form form");
//     let customSizeElem = document.querySelector("#personalize_custom_dogs");
//     if (!customSizeElem) {
//       customSizeElem = document.createElement("input");
//       customSizeElem.type = "hidden";
//       customSizeElem.name = "properties[_custom_size]";
//       customSizeElem.id = "personalize_custom";
//       customSizeElem.value = true;
//       productForm.appendChild(customSizeElem);
//     }
//   }
// }

function custom_addtocart_fun(product, open_drawer) {
  fetch(`${routes.cart_add_url}`, {
    method: 'POST',
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(product)
  })
    .then(response => response.json()).then(response => {
      // console.log("res..",response);   
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally((e) => {
      if (open_drawer) {
        // reset the  product data normal
        // document.querySelectorAll(".bundle_qty .quantity__input").forEach(input => {
        //   input.value = 0;
        // });
        const this_cartDrawer = document.querySelector('cart-drawer');
        this_cartDrawer.refresh(true);
      }

    });
}

// // Format price function (if needed)
// function formatPrice(price) {
//   return (price / 100).toFixed(2); // Shopify stores prices in cents
// }

var stickyBarcart = document.querySelector(".sticky-bar-wrap .cart_icon");
if (stickyBarcart) {
  stickyBarcart.addEventListener('click', function () {
    document.querySelector(".header__icon.header__icon--cart").click();
  });
}
document.addEventListener("click", function (event) {
  const dropdown = document.querySelector(".dimension-custom-dropdown");
  const dropdownButton = document.querySelector(".dimension-custom-dropdown .custom-dropdown-button");

  if (dropdown && dropdownButton) {
    // Check if the clicked element is NOT inside the dropdown
    if (!dropdown.contains(event.target)) {
      dropdownButton.classList.remove("active");
    }
  }
});

var viewDecButton = document.querySelector(".pdpdec-showhide-button");
var DecBlock = document.querySelector(".pdp-singlefaq-dec");
if (viewDecButton) {
  viewDecButton.addEventListener("click", function () {
    DecBlock.classList.toggle("active");
  });
}

// --- Share button, cart popup, cart discount ---
function initShareAndCartUI() {
  //Share product to some apps
  const shareButton = document.querySelector(".social-share-btn");

  if (shareButton) {
    shareButton.addEventListener('click', async () => {
      // ✅ Read URL dynamically when clicked
      const pdpTitle = document.querySelector(".product__info-wrapper .product__title h1")?.textContent;
      const currentUrl = new URL(window.location.href);

      // ✅ Custom size detection - remove variant if custom size active
      const isCustomSizeActive = document.querySelector(".custom-size.active") !== null;

      if (isCustomSizeActive) {
        currentUrl.searchParams.delete('variant');
      }

      // ✅ Add UTM parameters for tracking
      currentUrl.searchParams.set('utm_source', 'product_share');
      currentUrl.searchParams.set('utm_medium', 'share_button');
      currentUrl.searchParams.set('utm_campaign', 'pdp_variant_share');

      const variantId = currentUrl.searchParams.get('variant');
      if (variantId) {
        currentUrl.searchParams.set('utm_content', variantId);
      } else {
        currentUrl.searchParams.set('utm_content', isCustomSizeActive ? 'custom_size' : 'no_variant');
      }

      currentUrl.searchParams.set('shared', '1');

      const productUrl = currentUrl.href;
      const cleanUrl = new URL(window.location.href);
      const shareUrlClean = cleanUrl.href;

      // ✅ WhatsApp-friendly message — URL passed via the `url` field below
      // (not embedded here) so share targets recognise it as a link and the
      // UTM-tagged URL isn't duplicated in the message body.
      const shareMessage = `Hey! You should checkout this awesome product by Sleepycat, "${pdpTitle}"`;


      // ✅ GTM DataLayer event for analytics
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'share',
        method: 'share_button',
        content_type: 'product',
        item_id: variantId || 'no_variant',
        landing_page: productUrl,
        share_url_clean: shareUrlClean,
        page_location: window.location.href,
        page_title: pdpTitle || 'Product',
      });

      if (navigator.share) {
        try {
          await navigator.share({
            title: pdpTitle || 'SleepyCat',
            text: shareMessage,
            url: productUrl  // ✅ first-class URL field — carries the UTMs, recognised by all share targets
          });
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Error sharing:', err);
          }
        }
      }
    });
  }

  // csutom cart slider
  const cartPopup = document.querySelector(".cartitem-popup");
  const popupOverlay = document.querySelector(".popup-overlay");
  const closeButton = document.querySelector(".popup-closebutton");

  function closeCartPopup() {
    cartPopup.classList.remove("active");
    popupOverlay?.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    document.querySelector(".header-cart-icon").click();
  }

  document.addEventListener('click', function (event) {
    if (
      event.target.closest(".popup-closebutton.cart_item_popup") ||
      event.target.closest(".cartitem-popup .checkout-button-wrap")
    ) {
      closeCartPopup();
    }
  });

  popupOverlay?.addEventListener("click", function (e) {

    if (document.body.classList.contains('overflow-hidden')) {
      if (e.target === popupOverlay) {
        closeCartPopup();
      }
    }

    // if (e.target === popupOverlay) {
    //     closeCartPopup();
    //   }

  });
  // custom cart slider

  // cart discount

  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      // console.log("Cart",cart);
      const appliedDiscount = (cart.discount_codes?.[0]?.applicable)
        ? cart.discount_codes[0].code
        : null;
      const errorEl = document.querySelector(".discount-component .coupen-error");
      if (appliedDiscount) {
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.add("hidden");
        }
        if (appliedDiscount) {
          const appliedCoupon = document.querySelector(".applied-coupon-wrapper");
          appliedCoupon.classList.remove('hidden');
          appliedCoupon.querySelector(".cart-coupon").textContent = appliedDiscount;
        }

      }
    });
}
// cart popup drawer



let shortsSwiper;

function initShortsSwiper() {
  if (shortsSwiper) shortsSwiper.destroy(true, true);

  const container = document.querySelector('.shorts-container');
  const slidesPerView = parseInt(container?.dataset.slidesPerView || 5);

  shortsSwiper = new Swiper('.shorts-container', {
    slidesPerView: slidesPerView,
    spaceBetween: 10,
    slideToClickedSlide: false,
    loop: true,
    navigation: {
      nextEl: '.custom-next',
      prevEl: '.custom-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: slidesPerView,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: slidesPerView,
        spaceBetween: 10,
      }
    }
  });
}

// Lazy-init shorts swiper — only when visible (below fold, no need to init on page load)
(function() {
  var shortsEl = document.querySelector('.shorts-container');
  if (!shortsEl) return;
  var shortsInitialized = false;
  var shortsObserver = new IntersectionObserver(function(entries) {
    if (entries[0].isIntersecting && !shortsInitialized) {
      shortsInitialized = true;
      initShortsSwiper();
      window.addEventListener('resize', function() { initShortsSwiper(); });
      shortsObserver.disconnect();
    }
  }, { rootMargin: '300px 0px' });
  shortsObserver.observe(shortsEl);
})();



//AK custom code
// --- Pincode keydown validation ---
function initPincodeKeydown() {

  const pincodeInput = document.querySelector(".pincode-wrapper input#pincode");

  if (pincodeInput) {
    pincodeInput.addEventListener("keydown", function (e) {
      pincodeInput.setAttribute("data-pincodestatus", "invalid");

      // Clear the msg
      const delpicMsg = document.getElementById("delpicMsg");
      if (delpicMsg) {
        delpicMsg.innerHTML = "";
      }
      // call function when click enter key
      if (e.keyCode === 13) {
        checkPincode();
      }
    });

    ["keydown", "input", "paste"].forEach(eventType => {
      pincodeInput.addEventListener(eventType, function (e) {
        // console.log('hihih')
        return isNumberKey(e); // use the passed event object, not `event`
      });
    });


  }
}


//Ak custom code
var product_bed_btn = document.querySelector(".product__info-wrapper .buy-buttons-block button.product-form__submit");
if (product_bed_btn) {
  product_bed_btn.addEventListener('click', function (event) {
    if (this.closest('.buy-buttons-block').classList.contains('bed_pro_invalid')) {
      event.preventDefault();
      event.stopPropagation();

      const pin_check = document.querySelector(".delivery_input_main span#delpicMsg .pincode_unavailable");
      const pincodebed_first = document.querySelector(".delivery_input_main #checkforpincodefirst");

      if (pin_check) {
        pin_check.classList.add('error');
      } else {
        const pincodewrapper = document.querySelector(".pincode-wrapper");
        if (pincodewrapper) {
          pincodewrapper.classList.add('error');

          const delpicMsg = document.querySelector(".delivery_input_main span#delpicMsg");
          if (delpicMsg) {
            delpicMsg.innerHTML = '';
          }

          if (pincodebed_first) {
            pincodebed_first.style.display = "block";
          }

        }
      }
    }
  });

}

function checkPincode() {


  const pincodewrapper = document.querySelector(".pincode-wrapper");
  const pincodebed_first = document.querySelector(".delivery_input_main #checkforpincodefirst");
  const pincodebed_desc = document.querySelector(".delivery_input_main #checkPincodeDesc");

  if (pincodewrapper) {
    pincodewrapper.classList.remove('error');
    if (pincodebed_first) {
      pincodebed_first.style.display = "none";
      // document.querySelector(".product-main-sticky-bar .sticky-addtocart-btn .loading__spinner").classList.remove('hidden');
    }

    if (pincodebed_desc) {
      pincodebed_desc.style.display = 'none';
    }
  }

  const buyButtonsBlock = document.querySelector(".product__info-container .buy-buttons-block");
  const pincodeInput = document.querySelector(".pincode-wrapper input#pincode");
  const iscustom_m = pincodeInput.getAttribute("data-custom") === "true";
  // console.log('iscustom',iscustom_m);

  if (!iscustom_m) {
    if (buyButtonsBlock) {
      if (!buyButtonsBlock.classList.contains("active")) {
        //delivery msg For size select
        const delpicMsg = document.querySelector(".delivery_input_main span#delpicMsg");
        if (delpicMsg) {
          delpicMsg.innerHTML = "<div>Please select a size to check the delivery timeline!</div>";
        }

        // check size error
        const errorExists = document.querySelectorAll(".product_customDropdown .size-selection-error").length < 1;
        if (errorExists) {
          const dropdown = document.querySelector(".product_customDropdown");
          if (dropdown) {
            const errorSpan = document.createElement("span");
            errorSpan.className = "size-selection-error";
            errorSpan.textContent = "Select appropriate size before adding to cart!";
            dropdown.appendChild(errorSpan);
          }
        }
        return false;
      }
    }
  }


  const pincodeval = parseInt(pincodeInput.value);
  const delpicMsg = document.querySelector(".delivery_input_main span#delpicMsg");

  if (pincodeval) {
    const pin_btn = document.querySelector(".pin-check");
    if (pin_btn) {
      // pin_btn.style.pointer-events = 'none';
      pin_btn.style.pointerEvents = 'none';
    }
  }



  function getCurrentTimestamp() {
    const now = new Date();
    const pad = num => String(num).padStart(2, '0');

    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  }

  const sku = pincodeInput.getAttribute('data-sku');
  var pro_type = pincodeInput.getAttribute("data-producttype");
  const ismto = pincodeInput.getAttribute("data-outofstock") === "true";
  //   let dogBed = false;
  // const quantitycontainer = document.querySelector('.price-per-item__container');
  // if (quantitycontainer) {
  //   const quantityEl = quantitycontainer.querySelector('.quantity');
  //   if (quantityEl && quantityEl.dataset.url?.includes('dog-beds')) {
  //     dogBed = true;
  //   }
  // }
  const iscustom = document.querySelector(".personalization_result")?.classList.contains("active") || pincodeInput.getAttribute("data-custom") === "true";
  // dogBed || pincodeInput.getAttribute("data-custom") === "true";

  // var personalizeblock = document.querySelector(".personalize_product_block");
  if (personalizeblock) {
  }
  const data = {
    pincode: pincodeval,
    sku: sku,
    //  ismto: ismto,
    iscustom: iscustom,
    orderdate: getCurrentTimestamp()
  };

  // Show loading message
  if (delpicMsg) {
    delpicMsg.innerHTML = "<div>Hold on while we get you the details</div>";
  }

  //get_store_location.js
  if (!Array.isArray(window.parentDataLayer)) {
    window.parentDataLayer = [];
  }

  dataLayer.push({
    'event': 'pin_check',
    'additional_attribute': pincodeval
  });


  const bed_type = ["bedbase_ohayo"];
  // Guard: checkNearbyLocations lives in optimised-store-locator.js. If that asset
  // didn't load (e.g. not included on this template), calling it would throw a
  // ReferenceError and abort checkPincode before the delivery-timeline fetch below
  // is ever scheduled. The nearby-stores widget is secondary, so it must never block
  // the primary delivery check. Also null-guard #storeContainer.
  if (!bed_type.includes(pro_type) && typeof checkNearbyLocations === "function") {
    checkNearbyLocations(pincodeval).then((a => {
      const e = document.getElementById("storeContainer");
      "" == a || null == a || 0 == a || null == a ? parentDataLayer.push({
        event: "store_PDP_shown",
        additional_attribute: "false | " + pincodeval
      }) : parentDataLayer.push({
        event: "store_PDP_shown",
        additional_attribute: "true | " + pincodeval
      });
      if (e) e.innerHTML = a;
    })).catch(() => {});
    // checkNearbyLocations(pincodeval).then((a) => {
    //   const e = document.getElementById("storeContainer");

    //   if (a === "" || a === null || a === 0) {
    //     parentDataLayer.push({
    //       event: "store_PDP_shown",
    //       additional_attribute: "false | " + pincodeval
    //     });
    //   } else {
    //     parentDataLayer.push({
    //       event: "store_PDP_shown",
    //       additional_attribute: "true | " + pincodeval
    //     });
    //   }

    //   if (e) e.innerHTML = a; // ✅ This prevents error if #storeContainer doesn't exist
    // });

  }
  //get_store_location.js

  setTimeout(function () {
    const pincodeStr = pincodeval?.toString().trim();

    // Validate pincode
    const val_length = pincodeInput.value.length;
    if (!pincodeStr || isNaN(pincodeStr)) {
      if (delpicMsg) {
        delpicMsg.innerHTML = "<div class='pincode_unavailable'>Please enter a pincode!</div>";
        const pin_btn = document.querySelector(".pin-check");
        if (pin_btn) {
          // pin_btn.style.pointer-events = 'none';
          pin_btn.style.removeProperty('pointer-events');
        }

        return;
      }
    } else if (val_length !== 6) {
      if (delpicMsg) {
        delpicMsg.innerHTML = "Please enter a 6 digit pin code";
        const pin_btn = document.querySelector(".pin-check");
        if (pin_btn) {
          // pin_btn.style.pointer-events = 'none';
          pin_btn.style.removeProperty('pointer-events');
        }
        return;
      }
    } else {

      // if(sku != " " && ismto != " " && iscustom != " "){
      // if (sku !== "" && sku != null && sku != 'null' && ismto !== "" && ismto != null && ismto !== false && iscustom !== "" && iscustom != null) {
      if (sku !== "" && sku != null && sku != 'null' && ismto !== "" && ismto != null && iscustom !== "" && iscustom != null) {



        //temp. comment reviews api
        fetch("https://aws-api.sleepycat.in/api/shopify/fetch/delivery-timeline", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer eyJhbGciOiJIUzI1NiJ9.dmFpYmhhdi5wYXJha2hAc2xlZXB5Y2F0Lmlu.ZB6HilINZe8PBFZ_SGYlWEEYAM6mBpDIxg5bEERvc1E"  // 👈 Replace with your actual token
          },
          body: JSON.stringify(data),
          redirect: "follow"
        })

          .then(response => response.json())
          .then(response => {
            // Show API message or fallback

            const result = response?.response?.result;

            const message = response?.response?.result;
            const messageStr = JSON.stringify(message).toLowerCase();

            if (messageStr.includes("not") && messageStr.includes("serviceable")) {
              if (delpicMsg) {
                delpicMsg.innerHTML = "<div class='pincode_unavailable'>" + message + "</div>";
              }
            } else if (messageStr.includes("invalid") && messageStr.includes("pincode")) {
              if (delpicMsg) {
                delpicMsg.innerHTML = "<div class='pincode_unavailable'>" + message + "</div>";
              }
            }


            //for bed
            if (response?.response?.result?.productPinCodeCheck) {
              const pincodecheck = response?.response?.result?.productPinCodeCheck;
              const pincodemsg = JSON.stringify(pincodecheck).toLowerCase();
              if (pincodemsg.includes("invalid")) {
                if (delpicMsg) {
                  delpicMsg.innerHTML = "<div class='pincode_unavailable error'>Sorry product not available for this delivery pincode</div>";
                }

                const pro_type = response?.response?.result?.product_type?.toLowerCase();
                // const pro_title = response?.response?.result?.item_name?.toLowerCase().replace(/\s+/g, '-');
                if (pro_type == 'bed' || pro_type == 'recliner') {
                  if (buyButtonsBlock) {
                    buyButtonsBlock.classList.add('bed_pro_invalid');
                  }
                }

              }
            } else {
              // if(buyButtonsBlock){
              //   buyButtonsBlock.classList.remove('bed_pro_invalid');
              // }

              if (pincodebed_first) {
                pincodebed_first.style.display = "none";
              }

              if (messageStr.includes("delivery_date")) {
                if (pincodebed_desc) {
                  const pro_type = response?.response?.result?.product_type?.toLowerCase();
                  if (pro_type == 'bed') {
                    pincodebed_desc.style.display = 'block';
                  }

                  document.querySelector(".product-main-sticky-bar .sticky-addtocart-btn .loading__spinner").classList.add('hidden');
                }
                if (buyButtonsBlock) {
                  buyButtonsBlock.classList.remove('bed_pro_invalid');
                }
              }

              // if(pincodebed_desc){
              //   pincodebed_desc.style.display = 'block';
              //    document.querySelector(".product-main-sticky-bar .sticky-addtocart-btn .loading__spinner").classList.add('hidden');
              // }



              //bundle page
              let bundle_tab = document.querySelector('.bundle_tab.bundle_tab_button[data-category="bed"]');
              if (bundle_tab) {
                bundle_tab.classList.add('pin_valid');
                bundle_tab.setAttribute('data-pincode', pincodeval);

                let bundle_content = document.querySelector('.bundle_data.bundle-info-container');
                if (bundle_content) {
                  bundle_content.querySelector('.bundle_info_wrapper .variant-container')?.classList.remove('hidden');
                  bundle_content.querySelector('.bundle_info_wrapper .bundle-action-container')?.classList.remove('hidden');
                  bundle_content.querySelector('.bundle_info_wrapper .delivery_input')?.classList.add('hidden');

                  const pincodeEligibleHTML = `
                      <div class="custombundle-check-pincode-setFor">
                        <span>Pincode is eligible for delivery:</span>
                        <span id="custombundle-setPinCode" class="px-1">${pincodeval}</span>
                        <span id="custombundle-changePinCode" class="fa fa-edit d-inline-block"></span>
                      </div>
                      `;

                  // Select the .product-titles-container element
                  const productTitlesContainer = document.querySelector('.bundle-content-wrapper .product-titles-container');

                  if (productTitlesContainer) {
                    productTitlesContainer.insertAdjacentHTML('afterend', pincodeEligibleHTML);
                  }
                  if (delpicMsg) {
                    delpicMsg.innerHTML = "";
                  }
                  if (pincodebed_first) {
                    pincodebed_first.style.display = "block";
                  }
                  if (pincodebed_desc) {
                    pincodebed_desc.style.display = 'none';
                  }
                  if (pincodeInput) {
                    pincodeInput.value = ''
                  }

                  document.querySelectorAll('.product-main-sticky-bar .add_to_bundle .bundle_btn').forEach(btn => btn.classList.add('hidden'));
                  document.querySelectorAll('.product-main-sticky-bar .add_to_bundle .bundle_btn.sticky-addtobundle-btn').forEach(btn => btn.classList.remove('hidden'));

                }
              }
              //End bundle page
            }



            let bundle_tab = document.querySelector('.bundle_tab.bundle_tab_button[data-category="bed"]');
            if (!bundle_tab) {
              const deliveryDate = response?.response?.result?.delivery_date;
              if (deliveryDate) {

                const data_dtime = response?.response?.result?.ETDAttr;
                const dateObj = new Date(deliveryDate);

                // Format: 27 May 2025
                const options = { day: '2-digit', month: 'short', year: 'numeric' };
                const formattedDate = dateObj.toLocaleDateString('en-GB', options);

                // if(formattedDate){
                //   const input = document.createElement('input');
                //   input.type = 'hidden';
                //   input.id = 'delivery_timeline';
                //   input.name = 'properties[delivery_timeline]';
                //   input.value = formattedDate;
                //   const form = document.querySelector(".product__info-wrapper product-form form");
                //   form.appendChild(input);
                // }
                const isCustomActive = document.querySelector(".variant-pill-list-wrap .custom-size")?.classList.contains("active");

                // console.log(formattedDate); // Output: "27 May 2025"
                const mtoMsg = response?.response?.result?.isMTOMsg;
                let html = "";

                if (!isCustomActive && mtoMsg !== "") {
                  // If NOT custom active and mtoMsg exists
                  html = '<div data-dtime="' + data_dtime + '" class="pincode_available pincode_valid ">' + mtoMsg + '</div>';
                } else {
                  // If custom is active (or mtoMsg is empty), show estimated delivery
                  if (ismto === false) {
                    html += '<div data-dtime="' + data_dtime + '" class="pincode_unavailable "> Uh-oh! Looks like we ran out of stock. But this pincode is eligible for express delivery in 2 days with Free Shipping!</div>';
                  } else {
                    html = '<div data-dtime="' + data_dtime + '" class="pincode_available pincode_valid ">';
                    html += 'Estimated Delivery: <div id="timerDayPincode" style="font-weight:500; display:inline;">' + formattedDate + '</div>';
                    html += '<br>Order within next <div id="timerPincode" style="font-weight:500; display:inline;"></div>';
                  }
                }


                if (delpicMsg) {
                  delpicMsg.innerHTML = html;

                  // Now inject and run the countdown timer script
                  const script = document.createElement("script");
                  script.innerHTML = `
                    var date = new Date();
                    date.setHours(14, 0, 0);
                    var dayDate = new Date("${deliveryDate}");
                    var totaldays = 0;
                    var countDownDate = 0;
              
                    function timer(){
                      countDownDate = new Date(date).getTime();
                      var now = new Date().getTime();
                      var distance = countDownDate - now;
              
                      if (distance <= 0) {
                        date.setDate(date.getDate() + 1);
                        countDownDate = new Date(date).getTime();
                        distance = countDownDate - now;
                      }
              
                      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
              
                      let dayDateFormatted = dayDate.toLocaleString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric"
                      });
              
                      var timerDay = document.getElementById("timerDayPincode");
                      var timerTime = document.getElementById("timerPincode");
              
                      if(timerDay){
                        timerDay.innerHTML = totaldays !== 0 ? totaldays : dayDateFormatted;
                      }
              
                      if(timerTime){
                        timerTime.innerHTML = hours + "h " + minutes + "m " + seconds + "s ";
                      }
                    }
              
                    timer();
                    var _countdownIntervalId = setInterval(timer, 1000);
                    document.addEventListener("visibilitychange", function() {
                      if (document.hidden) {
                        clearInterval(_countdownIntervalId);
                      } else {
                        timer();
                        _countdownIntervalId = setInterval(timer, 1000);
                      }
                    });
                  `;
                  delpicMsg.appendChild(script);
                  // document.body.appendChild(script);

                }

              }
            }


            let status = "valid";
            pincodeInput.setAttribute("data-pincodestatus", status);


            // document.querySelector("#checkforpincodefirst")?.style.display = "none";

            const pin_btn = document.querySelector(".pin-check");
            if (pin_btn) {
              // pin_btn.style.pointer-events = 'none';
              // pin_btn.style.pointerEvents = 'none';
              pin_btn.style.removeProperty('pointer-events');
            }
          })
          .catch(() => {
            // alert("Oops, something went wrong. Please try again.");
          });

      } else {
        if (delpicMsg) {
          delpicMsg.innerHTML = "<div class='pincode_unavailable'>Please try again or contact our representative for assistance.</div>";
        }
        const pin_btn = document.querySelector(".pin-check");
        if (pin_btn) {
          // pin_btn.style.pointer-events = 'none';
          pin_btn.style.removeProperty('pointer-events');
        }
        return;
      }

    }
  }, 1500);





}
function isNumberKey(t) {
  return !!/^[0-9]*$/.test(t.target.value) || (t.target.value = "", !1)
}

document.addEventListener('click', function (e) {
  if (e.target.id === 'custombundle-changePinCode') {

    const wrapper = e.target.closest('.bundle_info_wrapper');
    if (wrapper && wrapper.querySelector('.customBundleProduct')) {
      const remove_btn = wrapper.querySelector('.summaryActions button.customBundle-Remove');
      if (remove_btn) {
        remove_btn.click();

        setTimeout(function () {
          const pincode = wrapper.querySelector('.custombundle-check-pincode-setFor #custombundle-changePinCode');
          if (pincode) {
            pincode.click();
          }
        }, 300);
      }
    }


    const bundle_content = e.target.closest('.bundle-content-wrapper');
    const bundle_pinsuccess = e.target.closest('.custombundle-check-pincode-setFor');

    if (bundle_pinsuccess) {
      bundle_pinsuccess.remove();
    }

    if (bundle_content) {
      const variantContainer = bundle_content.querySelector('.bundle_info_wrapper .variant-container');
      const actionContainer = bundle_content.querySelector('.bundle_info_wrapper .bundle-action-container');
      const deliveryInput = bundle_content.querySelector('.bundle_info_wrapper .delivery_input');


      // Hide the first two and show delivery_input
      variantContainer?.classList.add('hidden');
      actionContainer?.classList.add('hidden');
      deliveryInput?.classList.remove('hidden');
    }

    const bundletab = document.querySelector('.bundle_tab.bundle_tab_button[data-category="bed"]');
    if (bundletab) {
      bundletab.classList.remove('pin_valid')
      bundletab.removeAttribute('data-pincode')
    }
    document.querySelectorAll('.product-main-sticky-bar .add_to_bundle .bundle_btn').forEach(btn => btn.classList.add('hidden'));
    document.querySelectorAll('.product-main-sticky-bar .add_to_bundle .bundle_btn.sticky-checkpin').forEach(btn => btn.classList.remove('hidden'));

  }

  document.getElementById("CartDrawer-Checkout").onclick = async function (e) {
    e.preventDefault();        // ✅ CRITICAL: Prevent form submission
    e.stopPropagation();       // ✅ CRITICAL: Stop event bubbling

    const cart = await fetch("/cart.js").then(res => res.json());
    const items = [];
    cart.items.forEach((item, index) => {
      items.push({
        item_id: item.sku,
        item_name: item.product_title,
        discount: item.original_price - item.discounted_price,
        index,
        item_brand: "SleepyCat",
        item_category: item.product_type,
        price: +(item.original_price / 100).toFixed(2),
        item_variant: item.variant_id,
        quantity: item.quantity,
        "deal-price": +(item.discounted_price / 100).toFixed(2),
      });
    });

    /* Your existing GTM event - EXACTLY as it was
    dataLayer.push({
      event: "gtm_event_begin_checkout",
      ecommerce: {
        currency: cart.currency,
        value: +(cart.original_total_price / 100).toFixed(2),
        items
      }
    });*/

    // Navigate to checkout after analytics
    window.location.href = '/checkout';
  };

  /* document.getElementById("applyDiscount").onclick = async function () {
  let couponCode = document.getElementById("cart-discount").value;
            dataLayer.push({
'event': 'coupon_offers_list_checkout',
                'additional_attribute': couponCode
            })
 }*/


  if (e.target.classList.contains('email-me-submitButton')) {
    const select = document.querySelector('.selected-unavailable-variant');
    const selectedValue = select.value;
    const emailInput = document.querySelector('.buyer-email');
    const emailValue = emailInput.value.trim();
    if (emailValue) {
      dataLayer.push({
        'event': 'notifyme_shown',
        'notify_sku': selectedValue
      });
    }
  }


  //     if (e.target.classList.contains('add-to-cart')) {
  //      fetch('/cart.js')
  //             .then(res => res.json())
  //             .then(cart => {
  //               const targetItem = cart.items
  //                 // const existingItem = cart.items.find(item => item.variant_id === currentvariantId);
  //                 //  const targetItem = existingItem || cart.items[0];
  //                   if(!targetItem) return;
  //             })
  // }

});




function getCurrentTimestamp() {
  const now = new Date();
  const pad = num => String(num).padStart(2, '0');

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
}

function formatDeliveryDate(dateStr) {
  if (!dateStr) return "";

  const date = new Date(dateStr);

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
}
function checkPincodePP() {
  console.log("hot delivery pincode API")
  const pincodeInput = document.querySelector("input#pincode");
  const showPincodeMsg = document.getElementById("checkPincodeDesc");
  const rawVal = pincodeInput.value.trim();

  if (!rawVal) {
    if (showPincodeMsg) { showPincodeMsg.innerText = "Please enter pincode"; showPincodeMsg.style.display = 'block'; }
    return;
  }
  if (rawVal.length < 6) {
    if (showPincodeMsg) { showPincodeMsg.innerText = "Please enter a 6 digit pincode"; showPincodeMsg.style.display = 'block'; }
    return;
  }

  const sku = pincodeInput.getAttribute('data-sku');
  const pincodeval = Number(rawVal);
  const iscustom = pincodeInput.getAttribute('data-custom') === 'true';
  const activeHandle = document.querySelector('.product-title-btn.active')?.getAttribute('data-handle') || '';
  const isCoverHandle = activeHandle.includes('dog-bed-cover') || activeHandle.includes('mattress-cover');
  const coverInventory = isCoverHandle ? (getSkuInventoryQty(sku) ?? 0) : 0;
  const isCoverProduct = isCoverHandle && coverInventory <= 0;
  const data = {
    pincode: pincodeval,
    sku: sku,
    iscustom: isCoverProduct ? true : iscustom,
    orderdate: getCurrentTimestamp()
  };
  fetch("https://aws-api.sleepycat.in/api/shopify/fetch/delivery-timeline", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer eyJhbGciOiJIUzI1NiJ9.dmFpYmhhdi5wYXJha2hAc2xlZXB5Y2F0Lmlu.ZB6HilINZe8PBFZ_SGYlWEEYAM6mBpDIxg5bEERvc1E"
    },
    body: JSON.stringify(data),
    redirect: "follow"
  })
    .then(response => response.json())
    .then(response => {
      const result = response?.response?.result;
      let message = response?.response?.result;
      let showPincodeMsg = document.getElementById("checkPincodeDesc");
      let messageStr = "";
      // console.log("pincodemsg", pincodemsg, "message", message);
      if (typeof message === "string") {
        messageStr = message
      }
      else {
        // Use local Shopify inventory (v.inventory_quantity) from bundle_data / variantMetafields
        const localInventory = getSkuInventoryQty(sku);
        const inventoryQty = localInventory !== null ? localInventory : (message.available_inventory ?? 0);

        // Determine MTO status locally using the same 4-condition check as isBundleVariantMTO
        let localIsMTO = false;
        if (window.bundle_data) {
          outerPP: for (const cat of Object.values(window.bundle_data)) {
            if (!Array.isArray(cat)) continue;
            for (const bp of cat) {
              const v = bp.variants?.find(v => v.sku === sku);
              if (v) {
                localIsMTO = v.is_mto === true && v.inventory_quantity <= 0 && v.available === true && v.inventory_policy === 'continue';
                break outerPP;
              }
            }
          }
        }

        if (inventoryQty < 1 && !localIsMTO && !message.isCustom) {
          messageStr = `Uh-oh! Looks like we ran out of stock. But this pincode is eligible for express delivery in 2 days with Free Shipping!`
        }
        else {
          if (message.reason) {
            messageStr = message.reason
          }
          else {
            if (message.isCustom || (message.isMTOMsg || "").trim() === "") {
              const deliveryDate = message?.delivery_date || message?.ETDAttr || "";
              const formattedDate = formatDeliveryDate(deliveryDate);
              console.log("formattedDate===", formattedDate)
              messageStr = "Estimated Delivery: " + formattedDate
            }
            else {
              messageStr = message.isMTOMsg
            }
          }
        }
      }
      showPincodeMsg.innerText = messageStr;
      showPincodeMsg.style.display = 'block';
    })
    .catch((e) => {
      console.log('Anything wrong', e);
      // alert("Oops, something went wrong. Please try again.");
    });
}


//End Ak custom code
